<template>
	<div>
		<section
			:class="{ 'outer-pad': !isOverlay, 'no-pad-all': isOverlay, 'no-overlay-title': isOverlay && !overlayTitle }"
			v-if="!showPaymentMessage || !isOverlay">
			<h1 v-if="isOverlay && !!overlayTitle" :class="{ 'overlay-header': true, fade: !!theLoadingMessage }" v-html="overlayTitle" />
			<div :class="{ 'pricing-layout': true, overlay: isOverlay, 'loading-spinner-overlay': showLoadingSpinner }">
				<Loading
					position="internal-absolute"
					:solidBackground="true"
					:text="theLoadingMessage || loadingProductsMessage || 'One moment...'"
					v-if="showLoadingSpinner" />
				<div :class="{ 'pricing-main': true }">
					<div class="pricing-cards">
						<div v-if="hasSubscription || featureLive" class="subscription-info">
							<h2 class="form-inputs-section-title" v-if="!featureOnly">Your PartnerUp Subscription</h2>
							<h2 class="form-inputs-section-title" v-if="featureOnly && !isOverlay">Your PartnerUp Opportunity Only Account</h2>

							<h3 v-if="!approved && hasSubscription" class="form-inputs-section-sub-title">
								Thanks for entering your card details, your account is pending approval...
							</h3>

							<p v-if="!loadedSubscriptionInfo">Loading subscription information...</p>

							<p v-if="!featureOnly && active && !trialling && loadedSubscriptionInfo && !giftedOnly">
								<span v-if="!fixedTerm && subscription && subscription.isYearly">
									{{ youAre }} <strong>yearly</strong> subscription that expires on the <strong>{{ endDate }}</strong
									>,
									<span v-if="cancelled"
										>, you cancelled this on the <strong>{{ cancelled.cancelled }}</strong
										>, it expires on the <strong>{{ cancelled.cancels }}</strong></span
									>.
								</span>
								<span v-if="!fixedTerm && subscription && !subscription.isYearly"
									>{{ youAre }} <strong>monthly</strong> subscription,
									<span v-if="cancelled"
										>you cancelled this on the <strong>{{ cancelled.cancelled }}</strong
										>, it expires on the <strong>{{ cancelled.cancels }}</strong></span
									>
									<span v-if="!cancelled"
										>it renews on the <strong>{{ periodEndDate }}</strong
										>.</span
									>
								</span>

								<span v-if="fixedTerm && subscription">
									<span v-if="!productName">This product</span>Your <strong v-if="productName">{{ productName }}</strong> expires on
									the <strong>{{ endDate }}</strong
									>.
								</span>

								<span v-if="cancelled">
									<br /><br />
									If you'd like to renew your subscription click the <strong>{{ accessStripeButtonLabel }}</strong> button below.
								</span>
							</p>

							<p v-if="!featureOnly && active && trialling && loadedSubscriptionInfo && subscription">
								You are currently on a <strong>free subscription</strong>, it expires on the <strong>{{ endDate }}</strong
								>.
							</p>

							<p v-if="!featureOnly && active && loadedSubscriptionInfo && giftedOnly">
								You are currently have <strong>{{ giftedOnly }}</strong> free request{{ giftedOnly > 1 ? "s" : "" }} available,
								{{ giftedOnly > 1 ? "they expire" : "it expires" }} on the <strong>{{ endDate }}</strong
								>.
							</p>

							<div v-if="!active && featureOnly && !isOverlay && !featureLive">
								<h3 class="request-panel-heading" v-if="!featureExpired">
									<span>How to Create Your Opportunity & What Happens Next</span>
								</h3>
								<h3 class="request-panel-heading" v-if="featureExpired">
									<span>How to Create A New Opportunity & What Happens Next</span>
								</h3>
								<div>
									<ul>
										<li>Click 'Create Your Opportunity'</li>
										<li>Fill in the required details</li>
										<li>Preview how it will appear to brands</li>
										<li>Make payment and submit for approval</li>
									</ul>

									<p>
										Once approved, your opportunity will go live on PartnerUp and our homepage for 3 or 6 months.<br />
										We'll also promote it in our monthly newsletter and social media.
										<br /><br />
										When a brand is interested, you'll receive their message (and details) via email so you can connect directly.
										<br /><br />
										Need help? Reach out at <a href="mailto:hello@partneruphub.com">hello@partneruphub.com</a>. <br /><br />
										<span @click="goto('opportunities/new')" class="button mini no-margin-top">Create your Opportunity</span
										><br /><br />
										<span @click="toggleFeatureTsCs" class="link">View the Ts & Cs here</span>
									</p>
								</div>
							</div>

							<div v-if="featureOnly && !isOverlay">
								<p v-if="featureLive">
									Your opportunity is live and is set to expire on the <strong>{{ featureExpires.expires }}</strong
									>.<br /><br />
									You can remove it early by clicking the <strong>End your Opportunity early</strong> button below.<br /><br />
									You can also email us at <a href="mailto:hello@partneruphub.com">hello@partneruphub.com</a> with a date you'd like
									it to be removed and we'll do that for you.<br />
									<span class="button mini" @click="removeFeature">End your Opportunity early</span>
								</p>
								<p v-if="featureExpires && featureExpires.expired && featureIsDone && !featureIsDone.pending">
									Your opportunity expired on the <strong>{{ featureExpires.expires }}</strong
									>.
								</p>
								<p v-if="featurePaid && featureIsDone && featureIsDone.pending">Your opportunity is pending approval...</p>
							</div>

							<p v-if="featureOnly && isOverlay && !featureLive">
								You can display your Opportunity for up to 3 or 6 months. <br /><br />Once your Opportunity is live you will have the
								option to remove it early. <br />You can also email us at
								<a href="mailto:hello@partneruphub.com">hello@partneruphub.com</a> with a date you'd like it to be removed and we'll
								do that for you.
							</p>

							<div class="stripe-portal" v-if="hasSubscription && !trialling">
								<img src="./../../assets/img/stripe.svg" alt="Stripe" class="stripe-logo" />

								<p>
									We use Stripe to manage payment and subscription information, click the button below if you'd like to do the
									following...
								</p>

								<ul>
									<li>View/Download invoices</li>
									<li>Update payment details</li>
									<li>Manage/Cancel your subscriptions</li>
									<li>Update your billing information</li>
								</ul>

								<span class="button mini" @click="getPortalLink">{{ accessStripeButtonLabel }}</span>
							</div>
						</div>
						<div class="pricing-card-wrap" v-if="!hasSubscription && !featureOnly && productList.length">
							<div class="card-tagline">For brands running a few key collabs</div>
							<article class="pricing-card green">
								<div class="card-content">
									<h4 class="card-name">Sprint</h4>
									<div class="card-price price-amount">{{ products.one_time.price }}</div>
									<span class="price-note"> One payment / 3 months access </span>
								</div>
								<div class="card-body">
									<ul>
										<li>Discover and connect with like-minded brands</li>
										<li>Plan &amp; secure collaborations</li>
										<li>Join opportunities posted by other brands</li>
										<li>Receive unlimited collab requests</li>
										<li>Access Ideas Area</li>
										<li>
											<strong> Includes a free partnerships planning call with our team </strong>
										</li>
									</ul>
								</div>
								<a class="card-button" :href="products.one_time.link"> Let's Sprint </a>
								<span class="payment-link" @click="generatePaymentLink('one_time')">Copy payment link</span>
								<p class="card-note">30 day money back guarantee</p>
							</article>
						</div>
						<div class="pricing-card-wrap" v-if="!hasSubscription && !featureOnly && productList.length">
							<div class="card-tagline">For brands collaborating regularly</div>
							<article class="pricing-card white">
								<div class="card-ribbon">
									<span class="ribbon-text"> Most Popular </span>
								</div>
								<div class="card-content">
									<h4 class="card-name">Growth</h4>
									<div class="card-price price-amount">{{ products.monthly.price }}</div>
									<span class="price-note"> renews monthly </span>
								</div>
								<div class="card-body">
									<p>
										Everything in
										<strong> Sprint </strong>
										with the flexibility of a monthly subscription.
										<br />
										<br />
										<em> Does not include the free partnerships planning call </em>
									</p>
								</div>
								<a class="card-button" :href="products.monthly.link"> Let's Grow </a>
								<span class="payment-link" @click="generatePaymentLink('monthly')">Copy payment link</span>
								<p class="card-note">Cancel at any time. 30 day money back guarantee</p>
							</article>
						</div>
						<div class="pricing-card-wrap" v-if="!featureLive && featureOnly && featuredProductInfo.price">
							<article class="pricing-card white">
								<div class="card-content">
									<h4 class="card-name">3 months on PartnerUp</h4>
									<div class="card-price price-amount">{{ featuredProductInfo.price }}</div>
								</div>
								<div class="card-body">
									<p>
										Once your Opportunity is live you will have the option to remove it early. <br />You can also email us at
										<a href="mailto:hello@partneruphub.com">hello@partneruphub.com</a> with a date you'd like it to be removed and
										we'll do that for you.
									</p>
								</div>
								<a class="card-button" :href="featuredProductInfo.link"> Pay now </a>
								<span class="payment-link" @click="generatePaymentLink('3month')">Copy payment link</span>
							</article>
						</div>
						<div class="pricing-card-wrap" v-if="!featureOnly">
							<div class="card-tagline">For brands needing 360 support</div>
							<article class="pricing-card brown">
								<div class="card-content">
									<h4 class="card-name">All-in</h4>
									<div class="card-price price-amount">£500</div>
									<span class="price-note"> per month / 3 month contract </span>
								</div>
								<div class="card-body">
									<p>
										<em> Your collaborations, powered by us. </em>
										<br />
										<br />
										We'll plan, manage, and deliver brand collaborations that align with your goals and campaigns - so you can
										focus on the bigger picture.
									</p>
								</div>
								<span class="card-button" @click="showAllInInfo = true"> Find out more </span>
								<p class="card-note spacer">&nbsp;</p>
							</article>
						</div>
					</div>
					<p class="payment-link-info" v-if="!hasSubscription && !featureOnly && productList.length">
						Need a payment link to send another teammate? Click one of the "Copy payment link" links above and paste it into an email to
						share with them.
					</p>
					<p class="payment-link-info" v-if="!featureLive && featureOnly && featuredProductInfo.price">
						Need a payment link to send another teammate? Click the "Copy payment link" link above and paste it into an email to share
						with them.
					</p>
				</div>
			</div>
		</section>

		<Pupup v-if="portalLink" @close="portalLink = ''" :shuffleUp="true">
			<template v-slot:content>
				<div class="stripe-pupup">
					<img src="./../../assets/img/stripe.svg" alt="Stripe" class="stripe-logo" />
					<p>Click the button below to access your Stripe portal.</p>
					<a :href="portalLink" class="button mini">{{ accessStripeButtonLabel }}</a>
				</div>
			</template>
		</Pupup>

		<Pupup v-if="showPaymentMessage" @close="closePaymentMessage" :shuffleUp="true">
			<template v-slot:content>
				<div class="stripe-pupup">
					<img src="./../../assets/img/stripe.svg" alt="Stripe" class="stripe-logo" />
					<p v-html="paymentMessageProcessed" />
				</div>
			</template>
		</Pupup>

		<Pupup v-if="showAllInInfo" @close="showAllInInfo = false" width="1000" title="All-in £500 per month / 3 month contract">
			<template v-slot:content>
				<h3 id="allin-modal-title">Can't go all-in on collabs? We'll take it from here.</h3>
				<p class="modal-subtitle">If you're lacking the time, team or expertise. We can bring your collaborations to life.</p>
				<div class="modal-intro">
					<p>
						Below is a quick overview of what to expect, but the best place to start is with a call to see if we're a good fit and answer
						any questions.
					</p>
				</div>
				<div class="modal-grid">
					<div class="modal-panel modal-panel--steps">
						<h4 class="modal-section-title">What to expect</h4>
						<ol class="modal-steps">
							<li>
								<strong> Step 1: </strong>
								Discovery call - so we can get to know your brand, goals and vision.
							</li>
							<li>
								<strong> Step 2: </strong>
								We'll share a collaboration strategy inline with your business goals and ideal brand partners for your approval.
							</li>
							<li>
								<strong> Step 3: </strong>
								We'll get to work;
								<ul class="modal-bullets">
									<li>Regular check-ins and bi-weekly calls (if needed)</li>
									<li>Planned and/or delivery of exciting collaborations and meaningful partnerships</li>
									<li>Tangible results and ROI</li>
								</ul>
							</li>
						</ol>
					</div>
					<div class="modal-panel modal-panel--deliverables">
						<h4 class="modal-section-title">Deliverables</h4>
						<p>Depending on your goals, you can expect 4-8 collaborations (some likely to be scheduled in the future)</p>
					</div>
				</div>
			</template>
			<template v-slot:footer-inner>
				<div class="modal-actions">
					<a
						class="button no-margin flip-colours"
						href="https://calendly.com/partneruphub/30min"
						target="_blank"
						rel="noopener"
						style="color: white !important">
						Book a call
					</a>
				</div>
			</template>
		</Pupup>
	</div>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import { useVueInstance, useDialogs } from "../../composables/useVueInstance";
import { TokenService } from "../../services/storage.service";
import general from "./../../utils/general";
import ApiService from "./../../services/api.service";
import { isUnauthorizedError } from "./../../utils/errorHandling";
import LoadingSpinner from "./../../components/LoadingSpinner.vue";
import Pupup from "./../../components/Display/Pupup.vue";
import Icon from "./../../components/Display/BaseIcon.vue";
export default {
	name: "Subscriptions",
	components: {
		Loading: LoadingSpinner,
		Icon,
		Pupup,
	},
	props: {
		isPublic: {
			type: Boolean,
			default: false,
		},
		isOverlay: {
			type: Boolean,
			default: false,
		},
		paymentRedirect: {
			type: String,
			default: "",
		},
		title: {
			type: String,
			default: "",
		},
		featureOnlyOverride: {
			default: null,
		},
	},
	setup(props, { emit }) {
		const { store, $toast, router, route } = useVueInstance();
		const { confirm } = useDialogs();

		// --- DATA TO REFS ---
		const currency = ref("");
		const productList = ref([]);
		const loadedProducts = ref(false);
		const portalLink = ref("");
		const showPaymentMessage = ref(false);
		const showAllInInfo = ref(false);
		const productLoadNeeded = ref(false);
		const hasDiscount = ref({});
		const theLoadingMessage = ref("");
		const loadingMessageLabels = ref([]);
		const paymentMessage = ref("");
		const checkingPaymentStatus = ref(false);

		// --- VUEX HELPERS TO DIRECT ACCESS/COMPUTED ---
		const updateLoadingText = (payload) => store.commit("general/updateLoadingText", payload);
		const updateVar = (payload) => store.commit("general/updateVar", payload);
		const toggleFeatureTsCs = () => store.commit("general/toggleFeatureTsCs");
		const printGlobalMessage = (payload) => store.commit("general/printGlobalMessage", payload);
		const subscriptionPupupPaymentComplete = () => store.commit("general/subscriptionPupupPaymentComplete");
		const loadDashboard = (payload) => store.dispatch("general/loadDashboard", payload);

		const subscription = computed(() => store.state.general.subscription);
		const subscriptionPaymentCompleteMessage = computed(() => store.state.general.subscriptionPaymentCompleteMessage);
		const featureOnly = computed(() =>
			typeof props.featureOnlyOverride === "boolean" ? props.featureOnlyOverride : store.state.general.featureOnly
		);
		const showLoadingSpinner = computed(
			() => theLoadingMessage.value || (!loadedProducts.value && loadingProductsMessage.value && showProducts.value)
		);

		const accessStripeButtonLabel = computed(() => {
			if (hasSubscription.value) return "Manage Subscription";
			return "Access Stripe";
		});

		// --- HELPER FUNCTIONS ---
		const formattedDate = (d) => {
			if (!d) return "";
			const currentYear = new Date().getFullYear();
			const y = parseInt(general.dateFormat("Y", d));
			const dateFormat = y === currentYear ? "F" : "F Y";
			return general.dateFormat("jS", d) + " of " + general.dateFormat(dateFormat, d);
		};

		// --- COMPUTED PROPERTIES ---
		const routeMeta = computed(() => {
			const records = route.matched || [];
			if (records.length) {
				const lastRecord = records[records.length - 1];
				return (lastRecord && lastRecord.meta) || {};
			}
			return route.meta || {};
		});

		const pageType = computed(() => routeMeta.value.type || "account");

		const overlayTitle = computed(() => {
			let defaultTitle = featureOnly.value ? "" : "You need to buy a subscription to continue";

			switch (pageType.value) {
				case "pitch":
					defaultTitle = "";
					break;
				case "request":
				case "requests":
				case "matches":
				case "match":
					defaultTitle = "";
					break;
			}
			return props.title || defaultTitle;
		});

		const productName = computed(() => {
			if (subscription.value && subscription.value.mainSubscripionProductId) {
				const product = subscription.value.products[subscription.value.mainSubscripionProductId] || {};
				return product?.name || "";
			}
			return "";
		});

		const fixedTerm = computed(() => !!subscription.value && !!subscription.value.fixedTerm);
		const active = computed(() => !!subscription.value && !!subscription.value.active);
		const giftedOnly = computed(() => (!!subscription.value && subscription.value.giftedOnly ? subscription.value.giftedOnly : 0));
		const hasSubscription = computed(() => !!active.value && !giftedOnly.value);

		const loadingProductsMessage = computed(() => {
			if (featureOnly.value) return "Loading options...";
			return "Loading subscriptions...";
		});

		const featureIsDone = computed(() => {
			return !!subscription.value && !!subscription.value.featureDone && Object.keys(subscription.value.featureDone).length > 0
				? subscription.value.featureDone
				: false;
		});

		const featureApproved = computed(() => featureIsDone.value && !!featureIsDone.value.approved);

		const featureExpires = computed(() => {
			return featureIsDone.value && (featureApproved.value || !featureIsDone.value.current)
				? { expired: !featureIsDone.value.current, expires: formattedDate(featureIsDone.value.expires) }
				: false;
		});

		const featureExpired = computed(() => featureIsDone.value && !featureIsDone.value.current && !featureIsDone.value.pending);
		const featurePaid = computed(() => featureIsDone.value && !!featureIsDone.value.paid);
		const featureLive = computed(() => featureIsDone.value && !!featureIsDone.value.approved && !!featureIsDone.value.current);
		const approved = computed(() => true);
		const youAre = computed(() => (approved.value ? "You are currently on a " : "You will be on a "));
		const currencySymbol = computed(() => (currency.value === "gbp" ? "£" : "$"));

		const featuredProductInfo = computed(() => {
			if (!products?.value?.one_time || !featureOnly.value) return { price: "" };
			return products.value.one_time;
		});

		const showProducts = computed(() => {
			if (featureOnly.value) {
				return !!featureIsDone.value && !featurePaid.value && !featureExpired.value;
			}
			return !hasSubscription.value;
		});

		const cancelled = computed(() => {
			if (!!subscription.value && !!subscription.value.cancels) {
				return {
					cancels: formattedDate(subscription.value.cancels.cancel_at),
					cancelled: formattedDate(subscription.value.cancels.cancelled_at),
				};
			}
			return false;
		});

		const trialling = computed(() => !!subscription.value && !!subscription.value.trialling);

		const loadedSubscriptionInfo = computed(() => !!subscription.value && !!subscription.value.expires);
		const endDate = computed(() => (loadedSubscriptionInfo.value ? formattedDate(subscription.value.expires.subscription) : ""));
		const periodEndDate = computed(() => (loadedSubscriptionInfo.value ? formattedDate(subscription.value.expires.period) : ""));

		const products = computed(() => {
			let frequencies = featureOnly.value ? ["one_time"] : ["monthly", "one_time"],
				prods = {};

			productList.value.forEach((product) => {
				frequencies.forEach((frequency) => {
					if (!product.prices[frequency] || !!prods[frequency]) return;
					prods[frequency] = product.prices[frequency];
					prods[frequency].price = general.formatMoney(prods[frequency].unit_amount, currencySymbol.value);
				});
			});

			return prods;
		});

		const discountMessage = computed(() => (Object.keys(hasDiscount.value).length > 0 ? hasDiscount.value.message : ""));
		const paymentMessageProcessed = computed(() =>
			paymentMessage.value && paymentMessage.value !== "default"
				? paymentMessage.value
				: "Thank you! Your payment has been processed. Now the fun begins - let's find you some incredible brands to partner with."
		);

		// --- METHODS ---
		const getApiErrorMessage = (error, fallback) => {
			return error?.response?.data?.error || error?.response?.data?.message || fallback;
		};

		const showApiErrorToast = (error, title, fallback) => {
			if (isUnauthorizedError(error)) return;
			const message = getApiErrorMessage(error, fallback);
			if (message) $toast.error(message, title);
		};

		const loadingMessage = (message, label = "") => {
			if (typeof message === "boolean" && message) message = "One moment...";
			const index = loadingMessageLabels.value.indexOf(label);
			if (message) {
				if (index === -1) loadingMessageLabels.value.push(label);
				theLoadingMessage.value = message;
			} else {
				if (index > -1) loadingMessageLabels.value.splice(index, 1);
				if (!loadingMessageLabels.value.length) theLoadingMessage.value = "";
			}
		};

		let checkProgress; // Forward declare for use in yearlyUpgrade
		let loadProducts; // Forward declare

		const paymentComplete = () => {
			printGlobalMessage({ message: "" });
			paymentMessage.value = subscriptionPaymentCompleteMessage.value;
			loadDashboard({
				callback: () => {
					if (!props.isOverlay) {
						loadProducts("paymentComplete");
					}
					subscriptionPupupPaymentComplete();
					updateVar({ varName: "subscriptionPaymentCompleteMessage", info: "" });
					showPaymentMessage.value = true;
				},
			});
			emit("paymentComplete");
			if (props.isOverlay) {
				emit("hidePupup");
			}
		};

		const checkPaymentStatus = () => {
			loadingMessage(true, "checkPaymentStatus");
			checkingPaymentStatus.value = true;
			ApiService.get("stripe/payment-status/" + route.params.checkoutSessionId)
				.then(() => {
					loadingMessage(false, "checkPaymentStatus");
					checkingPaymentStatus.value = false;
					let m = "default";
					switch (pageType.value) {
						case "request":
						case "requests":
						case "matches":
						case "match":
							m =
								"Thank you! Your payment has been processed. Now the fun begins - let's find you some incredible brands to partner with.";
							break;
						case "pitch":
							m = featureOnly.value
								? "Thanks, your payment has been processed successfully."
								: "Thanks for your payment, please close this window to continue with your pitch.";
							break;
					}
					updateVar({ varName: "subscriptionPaymentCompleteMessage", info: m });
					if (pageType.value === "matches") {
						router.push(route.path.split("/payment-processing")[0]);
					}
					paymentComplete();
				})
				.catch((err) => {
					console.error(err);
					loadingMessage(false, "checkPaymentStatus");
					checkingPaymentStatus.value = false;
				});
		};

		checkProgress = (callback) => {
			loadingMessage(true, "checkProgress");
			ApiService.get("users/webhooks-in-progress")
				.then((info) => {
					if (info.data.count > 0) {
						setTimeout(() => checkProgress(callback), 500);
						return;
					}
					loadDashboard({
						callback: () => {
							loadingMessage(false, "checkProgress");
							if (subscription.value && subscription.value.hasSubscription) {
								printGlobalMessage({ message: "" });
								emit("paymentComplete");
							}
							if (subscription.value && subscription.value.hasNewPayment) {
								showPaymentMessage.value = true;
								setTimeout(() => loadDashboard(), 5000);
							}
							if (callback) callback();
						},
					});
					if (info.data.recent) {
						loadProducts("users/webhooks-in-progress");
					}
				})
				.catch((err) => {
					console.error(err);
					setTimeout(() => checkProgress(callback), 2000);
				});
		};

		loadProducts = (label, doLoadingMessage = false) => {
			let method = "get",
				vars = { reload: true };
			loadedProducts.value = false;
			if (!loadedSubscriptionInfo.value) {
				productLoadNeeded.value = true;
				return;
			}
			if (featurePaid.value) {
				productLoadNeeded.value = false;
				return;
			}
			productLoadNeeded.value = false;
			if (props.paymentRedirect) {
				vars.redirect = props.paymentRedirect;
				method = "post";
			}

			if (doLoadingMessage) loadingMessage(true, "loadProducts");
			ApiService[method]("products", vars)
				.then((info) => {
					loadedProducts.value = true;
					currency.value = info.data.currency;
					productList.value = info.data.products;
					hasDiscount.value = info.data.hasDiscount;
					if (doLoadingMessage) {
						loadingMessage(false, "loadProducts");
					}
				})
				.catch((err) => {
					showApiErrorToast(err, "loadProducts", "Unable to load subscriptions.");
					loadingMessage(false);
				});
		};

		const removeFeature = () => {
			if (!featureIsDone.value) return;
			confirm("Are you sure you want to end your Opportunity early?", {
				title: "End Opportunity Early",
				okText: "Yes please",
				cancelText: "Cancel",
			})
				.then(() => {
					updateLoadingText(true);
					ApiService.delete("pitch/" + featureIsDone.value._id)
						.then(() => {
							updateLoadingText(false);
							loadDashboard({
								callback: () => {
									loadProducts("removeFeature", true);
								},
							});
							$toast.success("Your opportunity has ended");
						})
						.catch((err) => {
							updateLoadingText(false);
							showApiErrorToast(err, "removeFeature", "Unable to end this opportunity.");
						});
				})
				.catch((err) => {});
		};

		const goto = (type) => {
			if (type) router.push("/" + type);
		};

		const closePaymentMessage = () => {
			showPaymentMessage.value = false;
			if (props.isOverlay) {
				emit("close");
			}
		};

		const generatePaymentLink = async (frequency) => {
			loadingMessage(true, "generatePaymentLink");
			try {
				const r = await ApiService.get("payment-link/" + frequency);
				navigator.clipboard.writeText(r.data);
				$toast.success(
					"The payment link is copied, just paste it into an email and send it to the relevant team member to complete the payment.",
					"Payment Link Copied"
				);
			} catch (err) {
				console.error(err);
				showApiErrorToast(err, "generatePaymentLink", "Unable to generate the payment link.");
			} finally {
				loadingMessage(false, "generatePaymentLink");
			}
		};

		const purchase = () => loadingMessage(true, "purchase");

		const getPortalLink = () => {
			loadingMessage(true, "getPortalLink");
			ApiService.get("users/stripe-portal-url")
				.then((info) => {
					setTimeout(() => {
						portalLink.value = info.data.url;
					}, 1500);
					window.location.assign(info.data.url);
				})
				.catch((err) => {
					console.error(err);
					showApiErrorToast(err, "getPortalLink", "Unable to open Stripe right now.");
					loadingMessage(false);
				});
		};

		// --- WATCHERS ---

		watch(
			loadedSubscriptionInfo,
			() => {
				loadingMessage(false, "watch loadedSubscriptionInfo");
				if (!loadedSubscriptionInfo.value) {
					loadingMessage(true, "watch loadedSubscriptionInfo");
				} else if (productLoadNeeded.value) {
					loadProducts("watch loadedSubscriptionInfo");
				}
			},
			{ immediate: true }
		);

		// --- LIFECYCLE HOOKS ---
		onMounted(() => {
			general.posthogCapture("subscriptions-viewed", {
				isOverlay: props.isOverlay,
				pageType: pageType.value,
				featureOnly: featureOnly.value,
			});

			const meta = routeMeta.value;
			if (meta.paymentProcessing && route.params.checkoutSessionId) {
				checkPaymentStatus();
				return;
			}
			if (meta.paymentProcessing && !route.params.checkoutSessionId) {
				TokenService.removeBrandConnectResume();
			}
			if (subscriptionPaymentCompleteMessage.value) {
				paymentComplete();
				return;
			}
			loadProducts("onMounted", true);
			checkProgress();
		});

		// --- RETURN ---
		return {
			currency,
			productList,
			loadedProducts,
			portalLink,
			showPaymentMessage,
			productLoadNeeded,
			hasDiscount,
			theLoadingMessage,
			loadingMessageLabels,
			paymentMessage,
			subscriptionPaymentCompleteMessage,
			featureOnly,
			overlayTitle,
			fixedTerm,
			loadingProductsMessage,
			featureApproved,
			featureExpires,
			featureExpired,
			featurePaid,
			featureIsDone,
			pageType,
			discountMessage,
			youAre,
			approved,
			showProducts,
			cancelled,
			active,
			hasSubscription,
			trialling,
			loadedSubscriptionInfo,
			endDate,
			periodEndDate,
			currencySymbol,
			products,
			paymentMessageProcessed,
			toggleFeatureTsCs,
			removeFeature,
			goto,
			closePaymentMessage,
			loadingMessage,
			generatePaymentLink,
			formattedDate,
			purchase,
			getPortalLink,
			paymentComplete,
			productName,
			subscription,
			giftedOnly,
			featuredProductInfo,
			showAllInInfo,
			featureLive,
			checkingPaymentStatus,
			showLoadingSpinner,
			accessStripeButtonLabel,
		};
	},
};
</script>

<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";
@import "./../../assets/css/less/_helper.less";
.request-panel-heading {
	margin-top: 10px;
}
.no-overlay-title {
	margin-top: 15px;
}
.feature-terms-list {
	padding: 0 0 0 20px;
	li {
		margin-bottom: 10px;
		&:last-child {
			margin-bottom: 0;
		}
	}
}
.benefits-list {
	line-height: 1.9em;
	margin-bottom: 20px;
	li {
		margin-bottom: 10px;
		&:last-child {
			margin-bottom: 0;
		}
	}
}
.overlay-header {
	color: @guidedRose;
	margin-bottom: 15px;
	padding-right: 40px;
	font-size: 1.5em;
	&.fade {
		opacity: 0;
	}
}
.overlay-opener {
	font-size: 1.9em;
	font-weight: @bold;
	padding: 0;
	margin: 0.75em 0;
	color: @formDefaultColour;
}
.stripe-info {
	background-color: @formDefaultColour;
	padding: 10px;
	.rounded(5px);
	color: white;
	font-weight: @bold;
	span {
		color: inherit;
	}
}
a,
.link {
	color: @guidedRose !important;
	font-weight: @bold;
	cursor: pointer;
}

.link {
	&:hover {
		text-decoration: underline;
	}
}

.form-inputs-section-title {
	color: @guidedRose;
	&.overlay {
		margin-top: 15px;
	}
}

.form-inputs-section-sub-title {
	color: @guidedRose;
	margin-top: 10px;
}

.not-allowed {
	font-weight: @bold;
	color: @formDefaultColour;
}

.discount-message {
	background-color: @guidedRose;
	color: white;
	font-weight: @bold;
	padding: 10px;
	.rounded(5px);
}

.stripe-pupup {
	padding-top: 8px;
	.stripe-logo {
		width: 100px;
	}

	.button {
		margin: 0;
		&:not(.hollow) {
			color: white !important;
		}
	}
}
.stripe-portal {
	background-color: white;
	padding: 20px;
	.rounded(5px);
	margin: 30px 0;
	.elevation.card();

	.stripe-logo {
		width: 100px;
	}

	.button {
		margin: 0;
	}

	.link {
		color: @guidedRose;
		font-weight: @bold;
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}
	}
}
.desktop {
	display: none;
}
hr {
	margin: 1.5rem 0;
	border-width: 2px;
}
.form-inputs-section {
	position: relative;
}

.form {
	position: relative;
	&.subscriptions {
		padding-top: 54px;
	}
}

.outer-pad {
	&.is-overlay {
		padding: 0;
		.form {
			.form-inputs-section {
				&.panel {
					margin: 0;
				}
				&.overlay {
					padding-top: 1px;
				}
			}
		}
		.discount-message {
			margin-top: 20px;
		}
	}
}

.pricing-layout {
	display: flex;
	flex-direction: column;
	gap: 32px;
	align-items: stretch;
	background-color: #fff;
	position: relative;
	padding: 20px;
	border-radius: @radiusLg;
	.elevation.card();
	&.overlay {
		padding: 0;
		background-color: transparent;
		box-shadow: none;
	}
	> * {
		min-width: 0;
	}
	.pricing-header {
		text-align: center;
	}

	.pricing-title {
		font-size: 18px;
		line-height: 1;
		margin: 0 0 20px;
		opacity: 0.85;
	}

	.pricing-subtitle {
		margin: 0;
		line-height: 1.35;
		font-size: 40px;
	}

	.pricing-divider {
		border-color: fade(@formDefaultColour, 20%);
		margin: 40px auto;
		width: 20vw;
		border-width: 2px;
	}

	.pricing-info-panel {
		border-radius: @radiusHero;
		padding: 0 32px 0;
		display: flex;
		align-items: stretch;
		flex: 0 0 auto;

		a {
			color: #fff;
		}

		a:hover,
		a:focus {
			color: fade(#fff, 85%);
		}
	}

	.info-inner {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	.eyebrow {
		font-size: 16px;
		letter-spacing: 0.08em;
		text-transform: uppercase;
		color: inherit;
		margin: 0;
	}

	.info-title {
		font-size: 36px;
		line-height: 1.1;
		margin: 0 0 20px;
		color: inherit;
	}

	.info-copy {
		margin: 0;
		line-height: 1.5;
		opacity: 0.85;
		color: inherit;
	}

	.info-list {
		list-style: none;
		margin: 0;
		padding: 0;
		display: grid;
		gap: 12px;
	}

	.info-list li {
		position: relative;
		padding-left: 28px;
		line-height: 1.4;
		color: inherit;
	}

	.info-list li:before {
		content: "";
		position: absolute;
		left: 0;
		top: 4px;
		width: 18px;
		height: 18px;
		border-radius: @radiusCircle;
		background: #fff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		color: @formDefaultColour;
	}

	.info-list li:after {
		content: "";
		position: absolute;
		left: 5px;
		top: 6px;
		width: 6px;
		height: 10px;
		border-right: 2px solid @formDefaultColour;
		border-bottom: 2px solid @formDefaultColour;
		transform: rotate(45deg);
	}

	.pricing-main {
		display: flex;
		flex-direction: column;
		gap: 32px;
		flex: 1 1 auto;
		align-self: stretch;
		min-height: 0;
	}

	.pricing-cards {
		display: flex;
		flex-direction: column;
		gap: 24px;
		align-items: stretch;
		margin-top: auto;
		min-height: 100px;
	}

	.payment-link-info {
		margin: 0;
	}

	// wrapper to allow tagline to sit outside card
	.pricing-card-wrap {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.pricing-card {
		background: fade(@formDefaultColour, 10%);
		border-radius: @radiusHero;
		padding: 32px 28px;
		.elevation.card();
		display: flex;
		flex-direction: column;
		border: 1px solid fade(@formDefaultColour, 12%);
		min-height: 0;
		position: relative;
		overflow: hidden;
		p {
			color: inherit;
			&.card-note {
				font-size: 0.7em;
				margin: 6px 0 0;
				padding: 0;
				text-align: center;
				&.spacer {
					display: none;
				}
			}
		}
		.card-button {
			cursor: pointer;
		}
		.payment-link {
			display: block;
			margin-top: 20px;
			margin-bottom: 10px;
			text-align: center;
			font-size: 14px;
			color: @formDefaultColour;
			cursor: pointer;
		}
		&.brown {
			background: @guidedRoseBgStrong;
			border-color: fade(@guidedRose, 12%);

			a:not(.card-button) {
				color: #fff;
			}

			a:not(.card-button):hover,
			a:not(.card-button):focus {
				color: fade(#fff, 85%);
			}
		}
		&.white {
			background: #fff;
			border-color: fade(@formDefaultColour, 20%);
			color: @textStrong;

			.card-name,
			.price-amount {
				color: @textStrong;
				line-height: 1;
			}

			.card-button {
				background: @formDefaultColour;
				color: #fff;
				&:hover,
				&:focus {
					background: darken(@formDefaultColour, 6%);
				}
			}
		}
	}

	&.loading-spinner-overlay {
		overflow: hidden;
		.pricing-card {
			box-shadow: none;
		}
	}

	.card-ribbon {
		position: absolute;
		top: 20px;
		right: -45px;
		background: @guidedRose;
		color: #fff;
		padding: 3px 40px 2px;
		font-size: 8px;
		font-weight: 600;
		text-transform: uppercase;
		letter-spacing: 0.05em;
		transform: rotate(45deg);
		box-shadow: 0 4px 12px fade(@guidedRose, 30%);
		z-index: 1;
	}

	.ribbon-text {
		display: block;
		white-space: nowrap;
		color: inherit;
	}

	.card-content {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 15px;
		align-items: baseline;
	}

	.card-body {
		padding: 0 0 25px;
		/* grow to fill available space so the button sits aligned at the bottom */
		flex: 1 1 auto;
		p {
			margin: 0 0 15px;
			&:last-child {
				margin-bottom: 0;
			}
		}
		p,
		li {
			font-size: 1.1em;
		}
		ul {
			margin: 0;
			padding: 0;
			list-style: none;
			li {
				padding: 0 0 0.35em 1.5em;
				background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z"/></svg>');
				background-repeat: no-repeat;
				background-position: 0 0.3em;
				background-size: 1em 1em;
			}
		}
	}

	.card-name {
		margin: 0;
		font-size: 26px;
		font-weight: 600;
		color: inherit;
		flex: 0 0 50%;
	}

	.card-price {
		display: flex;
		flex-direction: column;
		flex: 0 0 50%;
		font-size: 32px;
		font-weight: 600;
		text-align: right;
	}

	// now outside of .card-price and should span full width
	.price-note {
		font-size: 14px;
		opacity: 0.75;
		margin: 0;
		padding: 0;
		text-align: right;
		flex: 0 0 100%;
	}

	// tagline styling above each card
	.card-tagline {
		position: relative;
		align-self: flex-start;
		background: fade(@formDefaultColour, 12%);
		color: @formDefaultColour;
		padding: 6px 10px;
		border-radius: @radiusPill;
		font-size: 12px;
		font-weight: 600;
		letter-spacing: 0.02em;
		line-height: 1;
		box-shadow: 0 6px 16px fade(@formDefaultColour, 10%);
	}

	/* Match tagline colors to the card variant inside this wrapper */
	.pricing-card-wrap:has(> .pricing-card.green) .card-tagline,
	.pricing-card-wrap:has(> .pricing-card.white) .card-tagline {
		background: fade(@formDefaultColour, 12%);
		color: @formDefaultColour;
		box-shadow: 0 6px 16px fade(@formDefaultColour, 10%);
	}

	.pricing-card-wrap:has(> .pricing-card.brown) .card-tagline {
		background: fade(@guidedRose, 12%);
		color: @guidedRose;
		box-shadow: 0 6px 16px fade(@guidedRose, 12%);
	}

	.card-button {
		margin-top: auto;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 14px 10px;
		border-radius: @radiusLg;
		font-weight: 600;
		text-decoration: none;
		transition:
			background 0.25s ease,
			color 0.25s ease,
			box-shadow 0.25s ease;
		color: #fff !important;
		box-shadow: 0 12px 30px fade(@formDefaultColour, 18%);
		background: @formDefaultColour;
		font-size: 1.2em;
		&:hover,
		&:focus {
			background: darken(@formDefaultColour, 6%);
			color: #fff;
		}
	}

	.pricing-card {
		&.brown {
			.card-button {
				box-shadow: 0 12px 30px fade(@guidedRose, 18%);
				background: @guidedRose;
				&:hover,
				&:focus {
					background: darken(@guidedRose, 6%);
				}
			}
		}
	}

	/* Modal styles */
	.pricing-modal {
		position: fixed;
		inset: 0;
		display: none;
		z-index: 999999999999;
		align-items: center;
		justify-content: center;
		padding: 24px 16px;
	}

	/* show when targeted */
	.pricing-modal:target {
		display: flex;
	}

	/* Ensure modal is hidden when aria-hidden is true */
	.pricing-modal[aria-hidden="true"] {
		display: none !important;
	}

	.modal-overlay {
		position: fixed;
		inset: 0;
		background: fade(#000, 60%);
	}

	.modal-dialog {
		position: relative;
		background: #fff;
		color: @textStrong;
		border-radius: @radiusXl;
		max-width: 880px;
		width: 100%;
		max-height: 100%;
		.elevation.modalWorkspace();
		display: flex;
		flex-direction: column;
		z-index: 1;
		overflow: hidden;
	}

	.modal-close {
		position: absolute;
		top: 10px;
		right: 12px;
		text-decoration: none;
		font-size: 26px;
		line-height: 1;
		background: transparent;
		color: fade(#121212, 60%);
		padding: 6px 10px;
		border-radius: @radiusMd;
	}

	.modal-close:hover,
	.modal-close:focus {
		background: fade(#121212, 6%);
		color: @textStrong;
	}

	.modal-header {
		padding: 22px 22px 10px;
		border-bottom: 1px solid fade(@formDefaultColour, 16%);
		flex-shrink: 0;
	}

	.modal-plan {
		display: inline-flex;
		align-items: center;
		margin: 0 32px 8px 0;
		padding: 8px 14px;
		font-size: 14px;
		font-weight: 700;
		letter-spacing: 0.04em;
		text-transform: uppercase;
		background: fade(@guidedRose, 12%);
		color: @guidedRose;
		border-radius: @radiusPill;
	}

	.modal-plan::before {
		content: "";
		display: inline-block;
		width: 8px;
		height: 8px;
		margin-right: 8px;
		border-radius: @radiusCircle;
		background: @guidedRose;
	}

	.modal-header h2 {
		margin: 0 32px 8px 0;
		font-size: 26px;
		line-height: 1.25;
	}

	.modal-subtitle {
		margin: 0 32px 0 0;
		opacity: 0.85;
	}

	.modal-body {
		padding: 18px 22px 24px;
		display: grid;
		gap: 18px;
		overflow-y: auto;
		overflow-x: hidden;
		flex: 1 1 auto;
		min-height: 0;
		.modal-intro {
			p {
				margin: 0;
				line-height: 1.55;
				color: @guidedRose;
			}
		}

		.modal-grid {
			display: grid;
			gap: 18px;
			grid-template-columns: 1fr;
		}

		.modal-panel {
			display: flex;
			flex-direction: column;
			gap: 14px;
			border-radius: @radiusXl;
			padding: 18px 20px;
			background: #fff;
			border: 1px solid fade(@formDefaultColour, 10%);
			.elevation.card();
			color: @textStrong;
			.modal-section-title {
				font-size: 20px;
				line-height: 1.35;
				font-weight: 600;
			}
		}

		.modal-panel--steps {
			.modal-steps {
				padding-left: 5px;
				list-style: none;
				li {
					margin-bottom: 10px;
					line-height: 1.5;
					&:last-child {
						margin-bottom: 0;
					}
				}
			}
		}

		.modal-panel--deliverables {
			position: relative;
			overflow: hidden;
			padding: 24px 24px 30px;
			background: fade(@guidedRose, 18%);
			color: @darkContrast;
			border: 1px solid fade(@guidedRose, 28%);
			box-shadow: 0 20px 45px fade(@guidedRose, 24%);
			.modal-section-title {
				color: inherit;
				margin: 0 0 0px !important;
				font-size: 20px;
				font-weight: 700;
				letter-spacing: 0.01em;
				text-transform: none;
			}
			p {
				color: inherit;
				margin: 0;
				line-height: 1.65;
				font-size: 16px;
				font-weight: 500;
			}
		}

		@media screen and (min-width: 960px) {
			.modal-grid {
				gap: 22px;
			}
		}
	}

	.modal-section-title {
		margin: 0;
		font-size: 22px;
	}

	.modal-steps,
	.modal-bullets {
		margin: 0;
		padding-left: 18px;
	}

	.modal-bullets {
		margin-left: 5px;
	}

	.modal-bullets li,
	.modal-steps li {
		margin-bottom: 6px;
	}

	.modal-actions {
		padding: 16px 22px 22px;
		display: flex;
		justify-content: flex-end;
		gap: 12px;
		border-top: 1px solid fade(@formDefaultColour, 16%);
		flex-shrink: 0;
	}

	.modal-cta {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 12px 16px;
		border-radius: @radiusLg;
		text-decoration: none;
		font-weight: 600;
		background: @guidedRose;
		color: #fff;
		box-shadow: 0 12px 30px fade(@guidedRose, 20%);
	}

	.modal-cta:hover,
	.modal-cta:focus {
		background: darken(@guidedRose, 6%);
		color: #fff;
	}
}

@media screen and (min-width: 768px) {
	.form {
		&.subscriptions {
			padding-top: 0;
		}
	}
}
@media screen and (min-width: 930px) {
	.pricing-layout {
		gap: 40px;

		.pricing-main {
			gap: 20px;
		}

		.pricing-cards {
			flex-direction: row;
			align-items: stretch;
		}

		.pricing-card-wrap {
			flex: 1 1 0;
			display: flex;
		}

		/* when showing subscription-info + one card, make info 2/3 width */
		.pricing-cards {
			.subscription-info {
				display: flex;
				flex-direction: column;
				flex: 2 1 0;
			}
			.pricing-card-wrap {
				flex: 1 1 0;
			}
		}

		/* ensure cards in a row have equal height */
		.pricing-card {
			flex: 1 1 auto;
			display: flex;
			flex-direction: column;
			p.card-note.spacer {
				display: block;
			}
			.payment-link {
				margin-top: 10px;
				margin-bottom: 0;
			}
		}
		.card-button {
			font-size: 1.1em;
		}
	}
}
@media screen and (min-width: 1024px) {
	.desktop {
		display: inline;
	}

	.mobile {
		display: none;
	}

	.benefits-list {
		margin-bottom: 0;
	}

	.subscriptions {
		display: flex !important;

		&.no-products {
			display: block;
		}
	}
	.pricing-layout {
		flex-direction: row;
		align-items: stretch;
		.pricing-main {
			flex: 1 1 auto;
		}

		.pricing-heading {
			display: grid;
			grid-template-columns: 1fr auto;
			align-items: end;
		}

		.heading-text {
			.heading-title {
				font-size: 42px;
			}
		}

		.pricing-cards {
			gap: 32px;
		}

		.pricing-divider {
			margin-bottom: 50px;
		}
	}
}
@media screen and (min-width: 1280px) {
	.subscriptions {
		.intro-wrap {
			width: 50%;
			max-width: 1000px;
		}

		&.no-products {
			.intro-wrap {
				width: 100%;
			}
		}
	}
}
.payment-links {
	background-color: white;
	padding: 20px;
	border-radius: @radiusXs;
	margin: 20px 0 30px;
	.elevation.card();
	border-left: 4px solid @guidedRose;

	h3 {
		color: @guidedRose;
		margin: 0 0 10px;
		font-size: 18px;
		font-weight: @bold;
	}

	p {
		margin: 0 0 15px;
		color: @formDefaultColour;
	}

	.button-group {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;

		.button {
			margin: 0;
			cursor: pointer;

			&:hover {
				transform: translateY(-1px);
				transition: transform 0.2s ease;
			}
		}
	}
}

@media screen and (max-width: 767px) {
	.payment-links {
		.button-group {
			flex-direction: column;

			.button {
				width: 100%;
				margin-bottom: 8px;
			}
		}
	}
}
</style>
